import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { DroneDetailsPanelComponent } from './components/drone-details-panel/drone-details-panel.component';
import { MapToolbarComponent } from './components/map-toolbar/map-toolbar.component';
import { ObserverEntityListComponent } from './components/observer-entity-list/observer-entity-list.component';
import { ObserverMapCanvasComponent } from './components/observer-map-canvas/observer-map-canvas.component';
import { ObserverPhotoModalComponent } from './components/observer-photo-modal/observer-photo-modal.component';
import { ObserverMapFacadeService } from './services/observer-map-facade.service';

@Component({
  selector: 'app-root',
  imports: [
    MapToolbarComponent,
    ObserverMapCanvasComponent,
    ObserverEntityListComponent,
    DroneDetailsPanelComponent,
    ObserverPhotoModalComponent,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App implements OnInit, OnDestroy {
  protected readonly facade = inject(ObserverMapFacadeService);

  ngOnInit(): void {
    this.facade.startRefreshing();
  }

  ngOnDestroy(): void {
    this.facade.dispose();
  }
}
